import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

export function isEnabled() {
  return true;
}

const relationshipPage: FlowPage = {
  slug: () => 'relationship',
  isEnabled,
  title: () => 'Are you the owner of this home?',
  subtitle: () => "We have additional questions if you're an agent.",
  autoAdvance: () => true,
  questions: (): FlowQuestion[] => [
    {
      key: 'seller.relation_to_owner',
      type: 'radio_single_select',
      options: [
        {
          label: 'Yes, I own this home',
          value: 'Self',
        },
        {
          label: 'No, I’m an agent',
          value: 'Agent',
        },
        {
          label: 'I’m an agent, and I own this home',
          value: 'AgentAndOwner',
        },
        {
          label: 'Other',
          value: 'other',
          followUps: [
            {
              key: 'seller.relation_to_owner.other',
              type: 'single_line',
              label: 'Describe your relationship to this home',
            },
          ],
        },
      ],
    },
  ],
};

export default relationshipPage;
